export default {"src":"/_next/static/media/planet_mark_white.1a6935ca.svg","height":45,"width":56,"blurWidth":0,"blurHeight":0};